
import React from 'react';
import { ApolloClient, ApolloProvider, from, HttpLink, InMemoryCache } from '@apollo/client';
import { Auth } from '@aws-amplify/auth';
import { RetryLink } from 'apollo-link-retry';
import { onError } from '@apollo/client/link/error';
import { split } from 'postcss/lib/list';
import { createAuthLink } from 'aws-appsync-auth-link';
import { Amplify } from 'aws-amplify';
import RouterMain from './RouterMain/RouterMain';
import { Provider } from 'react-redux'
import store from './app/store.js'
import "@fontsource/dm-sans"; // Defaults to 400
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/700.css";

Amplify.configure({
  region: 'us-east-1',
  userPoolId: 'us-east-1_62yiCCLBJ',
  // userPoolWebClientId: 'k5j6f51hbpfc67hivu03c195g',
  userPoolWebClientId: '4q2hqj6j1hhscouqsvt6m0j7a6',
});


function App() {
  const config = {
    url: 'https://inbiyid2onh3fhr24i3armwmtm.appsync-api.us-east-1.amazonaws.com/graphql',
    region: 'us-east-1',
    auth: {
      type: 'AMAZON_COGNITO_USER_POOLS',
      jwtToken: async () =>
        (await Auth.currentSession()).getIdToken().getJwtToken()
    },
    complexObjectsCredentials: () => Auth.currentCredentials(),
    disableOffline: false,
  };
  // const handShake = createSubscriptionHandshakeLink(
  //   {
  //     auth: {
  //       type: config.auth.type,
  //       jwtToken: config.auth.jwtToken,
  //     },
  //     region: config.region,
  //     url: config.url,
  //   },
  //   httpLink
  // );
  const httpLink = new HttpLink({
    uri: config.url
  });
  
  const retryLink = new RetryLink({
    attempts: {
      max: 25,
      retryIf: (error, _operation) => {
        if (error) {
          console.log('test ' ,error)
          // setErrorCaptured(true);
        }
        return !!error;
      },
    },
    delay: {
      initial: 1000,
      max: 30000,
      jitter: true,
    },
  });
  const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
      });
    }
    if (networkError) {
      // console.log(`[Network error]: ${networkError}`);
      // setErrorCaptured(true); // Capture network error
    }
  });
  
  // const splitLink = split(
  //   httpLink
  // );
  
  
  const authLink = createAuthLink(config);
   const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: from([retryLink, errorLink, authLink, httpLink]),
  });
  console.log('client::: main:',client)
  return (
    <Provider store={store}>
    <ApolloProvider client={client}>
         <RouterMain />
    </ApolloProvider>
    </Provider>
  );
}

export default App;
